import apiUrl from '../../../../constants'
import axios from 'axios'
//import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import DatePicker from 'vue2-datepicker'
import Loader from './../../shared/loader'
import CryptoJS from 'crypto-js'
import printJS from 'print-js'
import Printd from 'printd'
import download from 'downloadjs'
import Pagination from './../../shared/pagination'
import orderdetailsaccordian from './../../orderdetailsAccordian'
import SimpleEncrypt from 'simple-encryptor'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
import common_helper from '../../../../common_helper'


import {
	BasicSelect
} from 'vue-search-select'
import 'vue-search-select/dist/VueSearchSelect.css'
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'order',
	components: {
		//Paginate,
		Pagination,
		DatePicker,
		JsonExcel,
		Loader,
		BasicSelect,
		orderdetailsaccordian
	},
	data() {
		return {
			selectedmerchant: {
				value: '',
				text: ''
			},
			merchantList: [],
			mid: '',
			listMerchantIdData: [],
			merchantnameFlt: '',
			backtoparent: false,
			multiselectflag: false,
			multiselecttrue: '',
			finalarrayofmultipleorder: [],
			MultiorderIDS: '',
			MultiorderArr: [],
			answer: '',
			orderid: '',
			isLoadingforxls: false,
			show: false,
			download: true,
			dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalPage: 0,
			totalRows: 0,
			currentPage: 1,
			pageLimit: 10,
			notfoundorderflag: false,
			NofFoundOrders: [],
			finalarray: [],
			values: '',
			// currentPage: 0,
			// totalRows:0,
			// getNewWarehouseData:'',
			listCancelReasonData: [],
			listOrdersData: [],
			listOrdersDataCsv: [],
			modalShow: false,
			modalMessageShow: false,
			displayMsg: false,
			successErrorMsg: "",
			pono: "",
			ponoFlt: "",
			shipidflt: "",
			fromDateFlt: "",
			toDateFlt: "",
			fromDateFltShip: "",
			toDateFltShip: "",
			newActionMsg: "",
			modelMessage: "",
			// totalPage: 0,
			// pageNo: 0,
			activeClass: 'btn-success',
			warningClass: 'btn-warning',
			showinvoicemodal: false,
			showSelectMerchant: false,
			shippingdata: [],
			shippinginvoicedata: [],
			shippinginvoicedatacal: [],
			clientdata: [],
			shippingcharges: 0,
			invoiceheadername: '',
			invoicephname: '',
			resultCount: 0,
			listClientData: [],
			listWarehouseData: [],
			clientid: '',
			client: '',
			warehouseid: '',
			merchantFlt: '',
			warehouse: '',
			ClientErr: '',
			WarehouseErr: '',
			ClientErr: '',
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			showSelectMerchant: false,
			orderCancelShow: false,
			cancelOrderId: '',
			loginuserid: '',
			cancelreasonid: '',
			orderstatuslist: [{
				'status': 'created'
			}, {
				'status': 'allocated'
			}, {
				'status': 'picked'
			}, {
				'status': 'packed'
			}, {
				'status': 'dispatched'
			}, {
				'status': 'cancelled'
			}, {
				'status': 'rto'
			},
			{
				'status': 'sr'
			},
			{
				'status': 'Rejected'
			}
			],
			searchchannel: '',
			searchstatus: '',
			searchbtoborder: '',
			channellist: [],
			isLoading: false,
			displayCancel: false,
			// perPage: 10,
			formattedDate: '',
			shipmentdetails: false,
			shipmentdetailslist: '',
			orderidshipment: '',
			fromDateFltStatus: '',
			toDateFltStatus: '',
			statusFlag: false,
			labelfromdate: '',
			labeltodate: '',
			userid: '',
			cancelOrderFlag: false,
			downloadButtonFlag: false,
			OthersReason: '',
			cancelReason: '',
			limitExeed: false,
			recordLimit: 0,
			showlist: true,
			selectedRow: {},
			filterData: {},
			PreviousDayFlag: false,
			warningflag: false,
			MultiorderArrFlag: false,
			OverOrdersErr: '',
			searchselfship: '',
			rejectdetails:false,
			rejectdetailslist: '',
			searchSLA :'',
			slaclient:[],
			slaflag:false,
			iscrossdock:false,
			checkCrossDock:false,
			orderid: '',
			rtvType:'',
			cancelshipmentid:'',
			loginuseremail : '',
		}
	},
	model: {
		totalqty: 0,
		grdtotalmrp: 0,
		totalamountpayable: 0,
		totaltaxablevalue: 0,
		totalcgstamt: 0,
		totalsgstamt: 0,
		totaligstamt: 0,
	},
	computed: {
		totalamountpayable: function () {
			return this.shippinginvoicedatacal.reduce(function (totalamountpayable, item) {
				return totalamountpayable + parseFloat(item.amountpayable)
			}, 0);
		},
		grdtotalmrp: function () {
			return this.shippinginvoicedatacal.reduce(function (grdtotalmrp, item) {
				return grdtotalmrp + (parseFloat(item.mrp) * parseFloat(item.pickqty));
			}, 0);
		},
		totalqty: function () {
			return this.shippinginvoicedatacal.reduce(function (totalqty, item) {
				return totalqty + parseFloat(item.pickqty);
			}, 0);
		},
		totaltaxablevalue: function () {
			return this.shippinginvoicedatacal.reduce(function (totaltaxablevalue, item) {
				return totaltaxablevalue + parseFloat(item.taxablevalue);
			}, 0);
		},
		totalcgstamt: function () {
			return this.shippinginvoicedatacal.reduce(function (totalcgstamt, item) {
				return totalcgstamt + parseFloat(item.cgstamount);
			}, 0);
		},
		totalsgstamt: function () {
			return this.shippinginvoicedatacal.reduce(function (totalsgstamt, item) {
				return totalsgstamt + parseFloat(item.sgstamount);
			}, 0);
		},
		totaligstamt: function () {
			return this.shippinginvoicedatacal.reduce(function (totaligstamt, item) {
				return totaligstamt + parseFloat(item.igstamount);
			}, 0);
		},
	},
	filters: {
		moment: function (date) {
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		this.calldateFunction();
		this.listClientData = '';
		this.key = '5VxHu9PR8QgPq7h67cUG0H34rYZQZmey';
		this.encryptor = SimpleEncrypt(this.key);
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);

		var innerpermissionEncrypt = window.localStorage.getItem('innerpermissiondata')
		var innerbytes = CryptoJS.AES.decrypt(innerpermissionEncrypt.toString(), 'Key');
		var innerplaintext = innerbytes.toString(CryptoJS.enc.Utf8);
		var innerdetail = JSON.parse(innerplaintext);
		this.getComponentPermission(innerdetail);

		this.reportname = this.$t('common.order')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		this.userid = userdetail.userid;
		var roleids = userdetail.roleid.split(',');
		for (var i = 0; i < roleids.length; i++) {
			if (roleids[i] == 40) {
				this.purchasingManager = parseInt(userdetail.roleid);
				this.isTrue = true;
			}
		}
		this.loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.loginuseremail = userdetail.email;
		this.pageNo = 0;
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		if (localStorage.getItem("selectedClient")!=='undefined')
		{
		this.getMerchantData();
		this.getSalesChannels();
		}
		var today = new Date();
		var today_12 = today.getHours();
		if (today_12 > 0 && today_12 < 6) {
			this.PreviousDayFlag = true;
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 1);
			this.toDateFlt = dt;
			if (this.toDateFlt) {
				this.warningflag = true;
			}
			else {
				this.warningflag = false;
			}
		}
		else {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.toDateFlt = this.currentDate;
		}
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss');

		// User access conditions
		//if (userdetail.roleid == 1 || userdetail.roleid == 4) {
		if (userdetail.roleid) {
			this.displayCancel = true
		}

		this.user_type = userdetail.utype;
		var slaconfig = window.localStorage.getItem('slaconfig');
		this.slaclient = JSON.parse(slaconfig);
		console.log(slaconfig);

		this.slaflag = this.slaclient.some(item => {
			if (item.clientid == this.clientid) {
			  return true;
			} else {
			  this.slaflag = false;
			  return false;
			}
		  });

		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				// this.getWarehouseList();
				this.getCancelReasonList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.client = this.clientid;
				// this.getWarehouseList();
				this.showSelectWarehouse = true;
				this.showSelectMerchant = true;
				this.getMerchantData();
				this.getCancelReasonList();
				if (userdetail.merchantid != null && userdetail.merchantid != '') {
					this.mid = userdetail.merchantid.toString()
					this.merchantnameFlt = this.mid
					this.showSelectMerchant = false;
				}

				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.showSelectMerchant = true;
				// this.getClientList();
				this.getCancelReasonList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
		this.getRecordLimit();
	}, // End computed
	methods: {
		showAddForm(data) {
			this.selectedRow = data
			this.showlist = false;
		},
		callParent() {
			this.showlist = true;
		},
		selectMerchant(data) {
			this.selectedmerchant = data;
			this.merchantnameFlt = data.value;
		},

		getRecordLimit() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({

			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getRecordLimit',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data) {
						this.recordLimit = result.data.data;


					}
				}, error => {
					console.error(error)
				})
		},
		startDownload() {
			this.isLoadingforxls = true;
		},
		finishDownload() {
			this.isLoadingforxls = false;
		},
		Choosetype() {
			this.show = true;
			this.download = false;
			if (!this.limitExeed) {
				this.getOrderListForXls(3)
			}
		},
		checkshipemtstatus() {
			this.$alertify.error(this.$t('common.orderCancelError'));

		},
		encryptData(encData) {
			return this.encryptor.encrypt(encData);
		},
		decryptData(decData) {
			return this.encryptor.decrypt(decData);
		},
		dateFormat(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},
		dateFormat1(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 00:00:00";
		},
		dateFormat2(date) {
			if (!date) return '';
			return moment(date).format('YYYY-MM-DD') + " 23:59:59";
		},
		calldateFunction: function () {
			this.currentDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
			this.toDateFlt = this.currentDate;
			var dt = new Date(this.currentDate);
			dt.setDate(dt.getDate() - 7);
			this.fromDateFlt = dt;
		},

		time() {
			var self = this
			this.datenow = moment().format()
			setInterval(self.time, 1000)
		},
		getComponentPermission(innerdetail) {
			var component = 'orders';
			var innerpermArr = {};
			for (var i = 0; i < innerdetail.length; i++) {
				if (innerdetail[i].controllerurl == component) {
					innerpermArr = innerdetail[i].permission;
					break;
				}
			}
			if (JSON.stringify(innerpermArr) == 'null') {
				//alert("wrong");
			} else {
				for (var i = 0; i < innerpermArr.length; i++) {
					if (innerpermArr[i].id == 'cancel') {
						this.cancelOrderFlag = true;
					}
					if (innerpermArr[i].id == 'download') {
						this.downloadButtonFlag = true;
					}
				}
			}

		},
		async PullRejectOrders(data) {
			this.input = ({
			  clientid: window.localStorage.getItem("selectedClient"),
			  warehouseid: window.localStorage.getItem("selectedWarehouse"),
			  saleschannel: data.saleschannel,
			  orderid: data.orderid,
			  shipmentid:data.shipmentid
			})
			this.isLoading = true;
			let result = await common_helper.getRestApiResponse('POST', 'pullRejectedOrder', this.input, this.$alertify)
			if (result && !result.errorDATA) {
			  this.isLoading = false;
			  if (result.data.status == true) {
				this.$alertify.success(result.data.msg)
			  } else {
				this.$alertify.error(result.data.msg)
			  }
			  this.getOrderList()
			}
		  },

		export(data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		hideShowdateFlt() {
			if (this.searchstatus == "created" || this.searchstatus == "") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = false;
				this.labelfromdate = '';
				this.labeltodate = '';
			}
			if (this.searchstatus == "allocated") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = true;
				this.labelfromdate = this.$t('editedjson.allocatedFromDate');
				this.labeltodate = this.$t('editedjson.allocatedToDate');
			}
			if (this.searchstatus == "picked") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = true;
				this.labelfromdate = this.$t('cancelPutawayPendingReport.pickedFromDate');
				this.labeltodate = this.$t('cancelPutawayPendingReport.pickedToDate');
			}
			if (this.searchstatus == "packed") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = true;
				this.labelfromdate = this.$t('editedjson.packedFromDate');
				this.labeltodate = this.$t('editedjson.packedToDate');
			}
			if (this.searchstatus == "dispatched") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = true;
				this.labelfromdate = this.$t('editedjson.dispatchedFromDate');
				this.labeltodate = this.$t('editedjson.dispatchedToDate');
			}
			if (this.searchstatus == "cancelled") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = true;
				this.labelfromdate = this.$t('cancelPutawayPendingReport.cancelledFromDate');
				this.labeltodate = this.$t('cancelPutawayPendingReport.cancelledToDate');
			}
			if (this.searchstatus == "rto") {
				this.fromDateFltStatus = '';
				this.toDateFltStatus = '';
				this.statusFlag = true;
				this.labelfromdate = this.$t('srReport.rTOFromDate');
				this.labeltodate = this.$t('srReport.rTOToDate');
			}
		},
		// getClientList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		this.listClientData = '';
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		if (this.warehouseid)
		// 			this.input = ({
		// 				warehouseid: this.warehouseid,
		// 			});
		// 		else {
		// 			this.input = {};
		// 		}

		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr,
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		Datechange() {
			var newDate = moment(this.toDateFlt).format('YYYY-MM-DD');
			this.currentDate = new Date(moment(this.currentDate).format('YYYY-MM-DD'));
			var dt = moment(this.currentDate).format('YYYY-MM-DD');
			if (newDate == dt) {
				this.warningflag = false;
			}
			else {
				this.warningflag = true;
			}
		},

		// getWarehouseList() {
		// 	this.pageno = 0;
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			clientid: this.clientid,
		// 		});
		// 		axios({
		// 			method: 'POST',
		// 			'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 			'data': this.input,
		// 			headers: {
		// 				'Authorization': 'Bearer ' + myStr
		// 			}
		// 		})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client || this.clientid == this.clientyy) {
		// 		this.clientid = this.client;
		// 		this.merchantnameFlt = '';
		// 		if (this.clientid)
		// 			this.getSalesChannels();
		// 		if (this.user_type != 'warehouse_user') {
		// 			this.merchantList = []
		// 			this.selectedmerchant = {}
		// 			this.listWarehouseData = []
		// 			this.getWarehouseList();
		// 			this.getMerchantData();
		// 			if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 				this.warehouse = this.warehouseid = '';
		// 			} else {
		// 				this.warehouse = ''
		// 			}
		// 		} else {
		// 			if (this.warehouseid && this.clientid) {
		// 				this.getMerchantData();

		// 			}
		// 		}
		// 	}
		// 	this.listOrdersData = [];
		// 	this.pageno = this.totalPage = 0;
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.pageno = this.totalPage = 0;
		// 	if (this.warehouseid) {
		// 		if (this.clientid) {
		// 			this.getSalesChannels();
		// 		} else {
		// 			this.getClientList();
		// 		}
		// 	}
		// },
		getCancelReasonList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.input = ({});
			axios({
				method: 'GET',
				'url': apiUrl.api_url + 'getCancelReasonList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.listCancelReasonData = result.data.dataset;
				}, error => {
					console.error(error);
				});
		},
		getSalesChannels() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			if (this.clientid == '') {
				this.WarehouseErr = this.$t('srReport.clientError');
				return false;
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'orderSalesChannelList',
				'data': {
					clientid: this.clientid
				},
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					this.channellist = result.data.data;
				}, error => {
					console.error(error);
				});
		},
		getMerchantData() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.input = ({
				clientid: this.clientid,
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'merchantList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listMerchantData = result.data;
					this.merchantList.push({
						value: '',
						text: this.$t('common.selectMerchantPlaceHolder')
					})
					for (var i = 0; i < this.listMerchantData.length; i++) {
						this.merchantList.push({
							'value': this.listMerchantData[i].merchantid,
							'text': this.listMerchantData[i].merchantname
						});
					}
				}, error => {
					console.error(error)
				})
		},
		getOrderCount(csvCheck = 0) {
			if (this.MultiorderIDS && csvCheck == 0 && this.MultiorderIDS.indexOf(",") > -1) {
				this.MultiorderArr = this.MultiorderIDS.split(",")
			}
			if (this.MultiorderIDS && csvCheck == 0 && this.MultiorderIDS.indexOf(",") == -1) {
				this.MultiorderArr = this.MultiorderIDS.split(",")
			}
			if (this.MultiorderArr.length > 200) {
				this.MultiorderArrFlag = true;
				this.OverOrdersErr = this.$t('orders.ordersAtATime');
			}
			else {
				this.MultiorderArrFlag = false;
			}
		},

		getOrderList(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');

			var dataFilter = {};
			this.finalarrayofmultipleorder = [];
			this.NofFoundOrders = [];
			this.values = '';
			this.finalarray = [];
			if (csvCheck == 2) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			if (csvCheck == 0) {
				this.show = false;
				this.download = true;
				this.limitExeed = false;
			}
			if ((this.ponoFlt == '' && this.MultiorderIDS == '') && (this.fromDateFlt == '' || this.fromDateFlt == null) && (this.toDateFlt == '' || this.toDateFlt == null)) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				this.totalRows = 0;
				return false;
			}

			var months;
			var fromDate = new Date(this.fromDateFlt);
			var ToDate = new Date(this.toDateFlt);
			months = ToDate.getMonth() - fromDate.getMonth() + (12 * (ToDate.getFullYear() - fromDate.getFullYear()))

			if ((this.ponoFlt == '' && this.MultiorderIDS == '') && months > 3) {
				this.$alertify.error(this.$t('common.dateError'));
				this.pageNo = this.totalPage = 0;
				this.totalRows = 0;
				this.listOrdersData = [];
				return false;
			}

			if (this.fromdate != "") {
				this.fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
			}
			if (this.todate != "") {
				this.todate = this.dateFormat(this.todate) + " 23:59:59";
			}

			if (csvCheck == 0 && this.MultiorderIDS == '') {
				this.MultiorderArr = [];
			}
			if (this.MultiorderIDS && csvCheck == 0 && this.MultiorderIDS.indexOf(",") > -1) {
				this.MultiorderArr = this.MultiorderIDS.split(",")
			}
			if (this.MultiorderIDS && csvCheck == 0 && this.MultiorderIDS.indexOf(",") == -1) {
				this.MultiorderArr = this.MultiorderIDS.split(",")
			}
			for (var i = 0; i < this.MultiorderArr.length; i++) {
				if (this.finalarrayofmultipleorder.indexOf(this.MultiorderArr[i]) == -1) {
					this.finalarrayofmultipleorder.push(this.MultiorderArr[i])
				}
			}
			if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
				this.$alertify.error(this.$t('common.clientError'))

				this.ClientErr = this.$t('common.clientError');
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}

			if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse")=='') {
				this.$alertify.error(this.$t('common.warehouseError'))
				this.pageNo = this.totalPage = 0;
				this.listOrdersData = [];
				return false;
			}
			this.isLoading = true;

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				pono: this.ponoFlt.trim(),
				shipmentid: this.shipidflt.trim(),
				fromDateFlt: this.dateFormat1(this.fromDateFlt),
				toDateFlt: this.dateFormat2(this.toDateFlt),
				fromDateFltShip: this.dateFormat1(this.fromDateFltShip),
				toDateFltShip: this.dateFormat2(this.toDateFltShip),
				fromDateFltStatus: this.dateFormat1(this.fromDateFltStatus),
				toDateFltStatus: this.dateFormat2(this.toDateFltStatus),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: window.localStorage.getItem("selectedClient"),
				searchchannel: this.searchchannel,
				searchstatus: this.searchstatus,
				csvData: csvCheck,
				userid: this.userid,
				Ordrids: this.finalarrayofmultipleorder,
				sellername: this.merchantnameFlt,
				searchbtoborder: this.searchbtoborder,
				searchselfship: this.searchselfship,
				slastatus : this.searchSLA,
				iscrossdock:this.iscrossdock ? 1 : 0,
				rtvType:this.rtvType


			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
			})
			this.filterData = this.input
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'orderList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 1) {
						if (result.data.data.length > 0) {
							//this.MultiorderArr = [];
							this.multiselecttrue = result.data.Multiselect
							if (this.multiselecttrue) {
								this.multiselectflag = true;
							} else {
								this.multiselectflag = false;
							}
							this.NofFoundOrders = result.data.NotFoundresult
							if (this.NofFoundOrders) {
								this.notfoundorderflag = true
								for (var i = 0; i < this.NofFoundOrders.length > 0; i++) {
									this.finalarray.push(this.NofFoundOrders[i].orderid)
								}
								this.values = this.finalarray.toString()

							}
							this.show = true;
							this.download = false;
							this.csvFields = {
								'customerfirstname': this.$t('editedjson.customerFirstName'),
								'customerlastname': this.$t('editedjson.customerLastName'),
								'totalitem': this.$t('editedjson.totalItem'),
								'totalquantity': this.$t('common.totalQuantity'),
								'saleschannel': this.$t('common.salesChannel'),
								'status': this.$t('client.status'),
								'createdby':  this.$t('common.createdBy'),
								'custmobile': this.$t('editedjson.Custmobile'),
								'gstamount': this.$t('editedjson.gstamount'),
								'modifieddatetime': this.$t('editedjson.modifiedDatetime'),
								'modifyby': this.$t('orders.modifyBy'),
								'orderdate': this.$t('orders.orderDate'),
								'createdDate': this.$t('common.createdDate'),
								'orderid': this.$t('orders.orderId'),
								'shipmentcount': this.$t('common.shipmentId'),
								'ordercode': this.$t('common.ordercode'),
								'shipstatus': this.$t('common.shipstatus'),
								'subtotal': this.$t('purchaseOrder.subtotal'),
								'createddatetime': this.$t('stockTransfer.createdDate'),
								'remark2':  this.$t('orders.orderCancelReason'),
								'ashipmentstatus':  this.$t('editedjson.ashipmentstatus'),
								'dispatcheddatetime': this.$t('editedjson.dispatcheddatetime'),
								'lastmodifieddate': this.$t('common.lastModifiedDate'),
								'shipbydate': this.$t('common.shipByDate'),
								'orderdispatchdatetime':this.$t('orders.shipmentHandoverDate'),
								'ordercompletionhrs':this.$t('orders.ordercompletionhrs'),
								'sellername':this.$t('common.merchantName'),
								'btoborder': this.$t('orders.isB2BOrder'),
								'slastatus': this.$t('sla.slastatus'),
								'breachedby': this.$t('sla.breachedby'),
								'sladatetime':this.$t('sla.sladatetime'),
							};

							var dateFilter = []// ['createddatetime', 'orderdate', 'modifieddatetime', 'shipbydate', 'lastmodifieddate', 'dispatcheddatetime'];
							var skipFilter = ['orderdate', 'shipmentstatusct', 'shipmentstatus', 'warehouseid','source','sladiff','nearbrach'];
							if (!this.slaflag) {
								const keysToAdd = ['slastatus','breachedby','sladatetime'];
								keysToAdd.forEach(key => {
								  if (!skipFilter.includes(key)) {
									skipFilter.push(key);
								  }
								});
							}

							this.listOrdersDataCsv = result.data.data;
							csvHelper.data.jsonToCSV(this.$t('common.order'), this.listOrdersDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}
					} else {
						this.listOrdersData = result.data.result;
						// this.MultiorderIDS=[];
						this.NofFoundOrders = [];
						this.values = '';
						this.finalarray = [];
						// this.MultiorderIDS = "";
						this.multiselecttrue = result.data.Multiselect
						if (this.multiselecttrue) {
							this.multiselectflag = true;
						} else {
							this.multiselectflag = false;
						}
						this.finalarrayofmultipleorder = [];
						this.NofFoundOrders = result.data.NotFoundresult
						if (this.NofFoundOrders) {
							this.notfoundorderflag = true
							for (var i = 0; i < this.NofFoundOrders.length > 0; i++) {
								this.finalarray.push(this.NofFoundOrders[i])
							}
							this.values = this.finalarray.toString()

						}

						if (result.data.errorCode == -1) {
							this.resultCount = 0;
						} else {
							// this.totalRows = result.data.count;
							// this.resultCount = result.data.totalRows;
							//
							// if (this.resultCount > 0) {
							// 	if (this.totalRows <= this.perPage) {
							// 		this.totalPage = 1;
							// 	} else {
							// 		this.totalPage = Math.ceil(this.resultCount / this.perPage);
							// 	}
							// }
							this.resultCount = result.data.totalRows;
							this.totalRows = result.data.totalRows;

							if (Number(this.totalRows) > Number(this.recordLimit)) {
								this.limitExeed = true
							}
							if (this.totalRows < 10) {
								this.totalPage = 1
							} else {
								this.totalPage = Math.ceil(this.totalRows / 10);
							}

						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})

		},
		getOrderListForXls(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var dataFilter = {};

			if (this.fromdate != "") {
				this.fromdate = this.dateFormat(this.fromdate) + " 00:00:00";
			}
			if (this.todate != "") {
				this.todate = this.dateFormat(this.todate) + " 23:59:59";
			}
			if (this.MultiorderIDS && csvCheck == 2 && this.MultiorderIDS.indexOf(",") > -1) {
				this.MultiorderArr = this.MultiorderIDS.split(",")
			}
			for (var i = 0; i < this.MultiorderArr.length; i++) {
				if (this.finalarrayofmultipleorder.indexOf(this.MultiorderArr[i]) == -1) {
					this.finalarrayofmultipleorder.push(this.MultiorderArr[i])
				}
			}
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';

			this.input = ({
				offset: (this.currentPage - 1) * 10,
				limit: this.pageLimit,
				pono: this.ponoFlt.trim(),
				shipmentid: this.shipidflt.trim(),
				fromDateFlt: this.dateFormat1(this.fromDateFlt),
				toDateFlt: this.dateFormat2(this.toDateFlt),
				fromDateFltShip: this.dateFormat1(this.fromDateFltShip),
				toDateFltShip: this.dateFormat2(this.toDateFltShip),
				fromDateFltStatus: this.dateFormat1(this.fromDateFltStatus),
				toDateFltStatus: this.dateFormat2(this.toDateFltStatus),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: window.localStorage.getItem("selectedClient"),
				searchchannel: this.searchchannel,
				searchstatus: this.searchstatus,
				csvData: csvCheck,
				userid: this.userid,
				Ordrids: this.finalarrayofmultipleorder,
				sellername: this.merchantnameFlt,
				searchbtoborder: this.searchbtoborder,
				searchselfship: this.searchselfship,
				slastatus : this.searchSLA,
				iscrossdock:this.iscrossdock ? 1 : 0,
				rtvType:this.rtvType
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'orderList',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (csvCheck == 3) {
						if (result.data.data.length > 0) {

							this.listReportDataforxls = [];
							//this.csvFieldsForXls = {
							this.csvFieldsForXls[this.$t('orders.orderId')]='orderid',
							this.csvFieldsForXls[this.$t('editedjson.customerFirstName')]='customerfirstname',
							this.csvFieldsForXls[this.$t('editedjson.customerLastName')]='customerlastname',
							this.csvFieldsForXls[this.$t('editedjson.totalItem')]='totalitem',
							this.csvFieldsForXls[this.$t('common.totalQuantity')]='totalquantity',
							this.csvFieldsForXls[this.$t('common.salesChannel')]='saleschannel',
							this.csvFieldsForXls[this.$t('client.status')]='status',
							this.csvFieldsForXls[this.$t('common.createdBy')]='createdby',
							this.csvFieldsForXls[this.$t('editedjson.Custmobile')]='custmobile',
							this.csvFieldsForXls[this.$t('editedjson.gstamount')]='gstamount',
							this.csvFieldsForXls[this.$t('editedjson.modifiedDatetime')]='modifieddatetime',
							this.csvFieldsForXls[this.$t('orders.modifyBy')]='modifyby',
							this.csvFieldsForXls[this.$t('orders.orderDate')]='orderdate',
							this.csvFieldsForXls[this.$t('common.createdDate')]='createdDate',
							this.csvFieldsForXls[this.$t('common.ordercode')]='ordercode',
							this.csvFieldsForXls[this.$t('common.shipstatus')]='shipstatus',
							this.csvFieldsForXls[this.$t('common.shipmentId')]='shipmentcount',
							this.csvFieldsForXls[this.$t('purchaseOrder.subtotal')]='subtotal',
							this.csvFieldsForXls[this.$t('stockTransfer.createdDate')]='createddatetime',
							this.csvFieldsForXls[this.$t('orders.orderCancelReason')]='remark2',
							this.csvFieldsForXls[this.$t('editedjson.ashipmentstatus')]='ashipmentstatus',
							this.csvFieldsForXls[this.$t('editedjson.dispatcheddatetime')]='dispatcheddatetime',
							this.csvFieldsForXls[this.$t('common.lastModifiedDate')]='lastmodifieddate',
							this.csvFieldsForXls[this.$t('common.shipByDate')]='shipbydate',
							this.csvFieldsForXls[this.$t('orders.shipmentHandoverDate')]='orderdispatchdatetime',
							this.csvFieldsForXls[this.$t('orders.ordercompletionhrs')]='ordercompletionhrs',
							this.csvFieldsForXls[this.$t('common.merchantName')]='sellername',
							this.csvFieldsForXls[this.$t('orders.isB2BOrder')]='btoborder',
							this.csvFieldsForXls[this.$t('sla.slastatus')]='slastatus',
							this.csvFieldsForXls[this.$t('sla.breachedby')]='breachedby',
							this.csvFieldsForXls[this.$t('sla.sladatetime')]='sladatetime',



							this.listReportDataforxls = result.data.data;
							const keysToRemove = [this.$t('sla.slastatus'),this.$t('sla.breachedby'),this.$t('sla.sladatetime')];
							if (!this.slaflag) {
							  keysToRemove.forEach(key => {
								if (this.csvFieldsForXls.hasOwnProperty(key)) {
								  delete this.csvFieldsForXls[key];
								}
							  });
							}

							// this.listReportDataforxls.forEach(function (entry) {
							// 	if (entry.shipbydate != '' && entry.shipbydate != null) {
							// 		entry.shipbydate = moment(entry.shipbydate).format('YYYY-MM-DD HH:mm:ss');

							// 	}
							// 	if (entry.lastmodifieddate != '' && entry.lastmodifieddate != null) {
							// 		entry.lastmodifieddate = moment(entry.lastmodifieddate).format('YYYY-MM-DD HH:mm:ss');

							// 	}
							// 	if (entry.dispatcheddatetime != '' && entry.dispatcheddatetime != null) {
							// 		entry.dispatcheddatetime = moment(entry.dispatcheddatetime).format('YYYY-MM-DD HH:mm:ss');

							// 	}
							// 	if (entry.createddatetime != '' && entry.createddatetime != null) {
							// 		entry.createddatetime = moment(entry.createddatetime).format('YYYY-MM-DD HH:mm:ss');

							// 	}
							// 	if (entry.orderdate != '' && entry.orderdate != null) {
							// 		entry.orderdate = moment(entry.orderdate).format('YYYY-MM-DD HH:mm:ss');

							// 	}
							// 	if (entry.modifieddatetime != '' && entry.modifieddatetime != null) {
							// 		entry.modifieddatetime = moment(entry.modifieddatetime).format('YYYY-MM-DD HH:mm:ss');

							// 	}
							// });

						} else {
							if (result.data.status == true) {
								this.$alertify.success(this.$t('common.reportSizeError'));
							} else {
								this.$alertify.error(result.data.msg.message);
							}
						}


					}

				}, error => {
					console.error(error);
				})
		},
		cancelOrder() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.orderCancelShow = false;
			if (window.localStorage.getItem("selectedClient") == '') {
				this.$alertify.error(this.$t('common.clientMsg'));
				return false;
			}
			this.isLoading = true;
			if (this.OthersReason != '' || this.OthersReason != null) {
				this.cancelReason = this.OthersReason
			}
			if (this.OthersReason == '' || this.OthersReason == null) {
				this.cancelReason = this.cancelreasonid
			}
			this.input = {
				clientid: window.localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				orderid: this.cancelOrderId,
				userid: this.loginuserid,
				cancelReason: this.cancelReason,
			}
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cancelOrder',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.$alertify.success(this.$t('orders.orderCancelled'));
						this.getOrderList();
						this.OthersReason = '';
						this.cancelreasonid = '';
					} else {
						this.$alertify.error(this.$t('orders.failed'));
					}
					this.isLoading = false;

				}, error => {
					console.error(error);
				});
		},
		cancelOrderShipment() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');

			this.orderCancelShow = false;
			if (window.localStorage.getItem("selectedClient") == '') {
				this.$alertify.error(this.$t('common.clientMsg'));
				return false;
			}
			this.isLoading = true;
			if (this.OthersReason != '' || this.OthersReason != null) {
				this.cancelReason = this.OthersReason
			}
			if (this.OthersReason == '' || this.OthersReason == null) {
				this.cancelReason = this.cancelreasonid
			}
			this.input = {
				clientid: window.localStorage.getItem("selectedClient"),
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				orderid: this.cancelOrderId,
				userid: this.loginuserid,
				shipmentid: this.cancelshipmentid,
				cancelreason: this.cancelReason,
				useremail: this.loginuseremail
			}
			
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'cancelOrderShipment',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr,
				}
			})
				.then(result => {
					if (result.data.data.ErrorCode == 0) {
						this.$alertify.success(this.$t('orders.orderCancelled'));
						this.getOrderList();
						this.OthersReason = '';
						this.cancelreasonid = '';
						this.cancelshipmentid= '';
					} else {
						this.$alertify.error(this.$t('orders.failed'));
					}
					this.isLoading = false;

				}, error => {
					console.error(error);
				});
		},
		orderreset() {
			this.orderCancelShow = false;
			this.cancelOrderId = '';
			this.cancelreasonid = '';
			this.OthersReason = '';
		},
		showorderinvoice(shippingid, type) {
			let userToken = window.localStorage.getItem('userToken')
			let myStr = userToken.replace(/"/g, '');
			this.showinvoicemodal = true;
			this.input = ({
				shippingid: shippingid,
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: window.localStorage.getItem("selectedClient"),
			});
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getOrderInvoiceData',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					var result = result.data.data[0];
					if (result.status != true) {
						console.error(result.msg);
					} else {
						this.shippingdata = result.data.invoicedata[0];
						this.shippinginvoicedata = result.data.invoicedata;
						this.clientdata = result.data.clientdata;
						this.shippingcharges = this.shippingdata.shippingcharges == null || this.shippingdata.shippingcharges == '' ? 0 : this.shippingdata.shippingcharges;
						if (type == 'taxinvoice') {
							this.invoiceheadername = "TAX INVOICE";
							this.invoicephname = "Name Of Pharmacist: ";
						} else if (type == 'custinvoice') {
							this.invoiceheadername = "Customer Acknowledgement";
							this.invoicephname = "Customer Signature & Phone No.";
						}
						this.shippinginvoicedatacal = [];
						for (var i = 0; i < this.shippinginvoicedata.length; i++) {
							var gst = 0;
							var totalmrp = 0;
							var amountpayable = 0;
							var taxablevalue = 0;
							var igstamount = 0;
							var cgstamount = 0;
							var sgstamount = 0;

							var sgstper = 0;
							var cgstper = 0;
							var igstper = 0;

							totalmrp = ((this.shippinginvoicedata[i].mrp * this.shippinginvoicedata[i].pickqty));
							amountpayable = totalmrp - (Number(this.shippinginvoicedata[i].invoiceleveldiscount));
							if (Number(this.shippinginvoicedata[i].hsnrate) > 0) {
								if (this.shippingdata.custstate == this.clientdata.state) {
									sgstper = Number(this.shippinginvoicedata[i].hsnrate) / 2;
									cgstper = Number(this.shippinginvoicedata[i].hsnrate) / 2;
									igstper = 0;
									gst = Number(sgstper) + Number(cgstper);
									taxablevalue = ((amountpayable) / (1 + (gst / 100)));
									igstamount = 0;
									cgstamount = ((taxablevalue) * (Number(sgstper) / 100));
									sgstamount = ((taxablevalue) * (Number(cgstper) / 100));
								} else {
									sgstper = 0;
									cgstper = 0;
									igstper = Number(this.shippinginvoicedata[i].hsnrate);
									gst = Number(igstper);
									taxablevalue = ((amountpayable) / (1 + (gst / 100)));
									igstamount = ((taxablevalue) * (Number(igstper) / 100));
									cgstamount = 0;
									sgstamount = 0;
								}
							} else {
								taxablevalue = amountpayable
								sgstper = 0;
								cgstper = 0;
								igstper = 0;
								igstamount = 0;
								cgstamount = 0;
								sgstamount = 0;
							}
							this.shippinginvoicedatacal.push({
								"productname": this.shippinginvoicedata[i].productname,
								"brand": this.shippinginvoicedata[i].brand,
								"strength": this.shippinginvoicedata[i].strength,
								"lotcontrol": this.shippinginvoicedata[i].lotcontrol,
								"expirydate": this.shippinginvoicedata[i].expirydate,
								"hsncode": this.shippinginvoicedata[i].hsncode,
								"pickqty": this.shippinginvoicedata[i].pickqty,
								"primaryuom": this.shippinginvoicedata[i].primaryuom,
								"mrp": this.shippinginvoicedata[i].mrp,
								"totalmrp": totalmrp,
								"discount": this.shippinginvoicedata[i].invoiceleveldiscount,
								"amountpayable": amountpayable,
								"taxablevalue": taxablevalue,
								"sgstper": sgstper,
								"cgstper": cgstper,
								"igstper": igstper,
								"igstamount": igstamount,
								"cgstamount": cgstamount,
								"sgstamount": sgstamount,

							})
						}
					}
				}, error => {
					console.error(error)
				})

		},
		// called onchange of client id
		getNewClientData() {
			this.pageNo = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.searchFlag = false;
			this.listOrdersData = [];
			this.ponoFlt = '';
			this.shipidflt = '';
			this.fromDateFlt = "";
			this.toDateFlt = "";
			this.fromDateFltShip = "";
			this.toDateFltShip = "";
			document.getElementById('ponoFlt').value = "";
			document.getElementById('shipidflt').value = "";


			if (this.client == "") {
				return false;
			} else {
				this.getOrderList();
			}
		},
		// getPaginationData(currentPage) {
		// 	this.pageNo = (currentPage - 1) * this.perPage;
		// 	this.getOrderList()
		// },
		onPageChange(page) {
			this.currentPage = page;
			window.localStorage.setItem('currentPage', this.currentPage)
			this.getOrderList()
		},
		getOrderSerach() {
			this.totalPage = 0;
			this.currentPage = 1;
			this.resultCount = 0;
			this.searchFlag = true;
			this.getOrderList(0);
		},
		resetOrderSerach() {
			this.slastatus=''
			this.selectedmerchant = {}
			this.merchantnameFlt = '';
			this.finalarrayofmultipleorder = [];
			this.NofFoundOrders = [];
			this.MultiorderArr = [];
			this.multiselectflag = false;
			this.multiselecttrue = '';
			this.values = '';
			this.finalarray = [];
			this.show = false;
			this.download = true;
			this.ClientErr = '';
			this.$validator.reset();
			this.ponoFlt = '';
			this.shipidflt = '';
			this.fromDateFlt = "";
			this.toDateFlt = "";
			this.fromDateFltShip = "";
			this.toDateFltShip = "";
			this.searchstatus = '';
			document.getElementById("searchstatus").value = '';
			this.searchbtoborder = '';
			this.searchselfship = '';
			this.searchchannel = '';
			this.listOrdersData = [];
			this.pageNo = 0;
			this.totalPage = 0;
			this.resultCount = 0;
			this.notfoundorderflag = false,
				this.NofFoundOrders = [],
				this.finalarray = [],
				this.totalRows = 0;
			this.searchFlag = false;
			this.statusFlag = false;
			this.fromDateFltStatus = '';
			this.MultiorderIDS = '';
			this.toDateFltStatus = '';
			this.searchSLA='';
			this.rtvType='';
			if (this.user_type == 'warehouse_user') {
				// this.client = '';
				// this.merchantList = [];
				this.listWarehouseData = [];
				// this.clientid = '';
			}
			else if (this.user_type == 'client_user') {
				// this.warehouse = '';
			} else {
				// this.client = '';
				// this.warehouse = '';
				// this.merchantList = [];
				this.listWarehouseData = [];
				// this.clientid = '';
			}
			// this.getOrderList();
		},
		formatPrice(value) {
			value = value ? value : 0;
			return Number.parseFloat(value).toFixed(2);
		},


		//shipmentDetails
		shipmentDetails(poid, shipmentcount) {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			var shipmentcount = shipmentcount;
			if (shipmentcount!=null) {
				this.shipmentdetailslist = '';
				this.orderidshipment = poid;
				this.input = {
					warehouseid: window.localStorage.getItem("selectedWarehouse"),
					clientid: window.localStorage.getItem("selectedClient"),
					orderno: this.orderidshipment,
					shipmentid:shipmentcount
				};
				axios({
					method: 'POST',
					'url': apiUrl.api_url + 'shipmentsDetailsOfOrder',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
					.then(result => {
						if (result.data.errorCode == 0) {
							this.shipmentdetailslist = result.data.data;
							this.shipmentdetails = true;
						} else {
							this.shipmentdetailslist = {};
							this.shipmentdetails = true;
						}
					}, error => {
						console.error(error)
					})
			}
		},
		showRejectInfo(poid){
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.shipmentdetailslist = '';
			this.orderid = poid;
			this.input = {
				warehouseid: window.localStorage.getItem("selectedWarehouse"),
				clientid: window.localStorage.getItem("selectedClient"),
				orderno: this.orderid
			};
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'rejectDetailsOfOrder',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					if (result.data.errorCode == 0) {
						this.rejectdetailslist = result.data.data;
						this.rejectdetails = true;
					} else {
						this.rejectdetailslist = {};
						this.rejectdetails = true;
					}
				}, error => {
					console.error(error)
				})
		},
		rejectdetailsClose() {
			this.rejectdetails = false;
			this.rejectdetailslist = '';
		},

		//shipmentdetails Close
		shipmentDetailsClose() {
			this.shipmentdetails = false;
			this.orderidshipment = '';
			this.shipmentdetailslist = '';
		},
		//validate all form fields on onsubmit()
		onSubmit: function () {
			this.$validator.validateAll().then(() => {
				console.log('form is valid', this.model)
			}).catch(() => {
				console.log('errors exist', this.errors)
			});
		},
		viewOrderData(data) {
			this.pono = data.poid;
			window.localStorage.setItem('pono', this.pono);
			window.localStorage.setItem('client', this.client);
			window.location.href = apiUrl.baseUrl + 'orderdetails';
		},
		number2text(value) {
			var res = '';
			var fraction = Math.round(this.frac(value) * 100);
			var f_text = "";

			if (fraction > 0) {
				f_text = "And " + this.convert_number(fraction) + " Paise";
			}
			return this.convert_number(value) + " Rupees " + f_text + " Only";
		},
		frac(f) {
			return f % 1;
		},

		convert_number(number) {
			if ((number < 0) || (number > 999999999)) {
				return "NUMBER OUT OF RANGE!";
			}
			var Gn = Math.floor(number / 10000000); /* Crore */
			number -= Gn * 10000000;
			var kn = Math.floor(number / 100000); /* lakhs */
			number -= kn * 100000;
			var Hn = Math.floor(number / 1000); /* thousand */
			number -= Hn * 1000;
			var Dn = Math.floor(number / 100); /* Tens (deca) */
			number = number % 100; /* Ones */
			var tn = Math.floor(number / 10);
			var one = Math.floor(number % 10);
			var res = "";

			if (Gn > 0) {
				res += (this.convert_number(Gn) + " Crore");
			}
			if (kn > 0) {
				res += (((res == "") ? "" : " ") +
					this.convert_number(kn) + " Lakh");
			}
			if (Hn > 0) {
				res += (((res == "") ? "" : " ") +
					this.convert_number(Hn) + " Thousand");
			}
			if (Dn) {
				res += (((res == "") ? "" : " ") +
					this.convert_number(Dn) + " Hundred");
			}

			var ones = Array("", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen");
			var tens = Array("", "", "Twenty", "Thirty", "Fourty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety");

			if (tn > 0 || one > 0) {
				if (!(res == "")) {
					res += " And ";
				}
				if (tn < 2) {
					res += ones[tn * 10 + one];
				} else {

					res += tens[tn];
					if (one > 0) {
						res += (" " + ones[one]);
					}
				}
			}
			if (res == "") {
				res = "zero";
			}
			return res;
		},
		print() {
			const d = new Printd();
			var buffer = '';

			var cssText = `
body{
-webkit-print-color-adjust:exact;
}
table {
  font-size: 14px !important;
  margin-top: 10px !important;
}
,
@media print {
  table {
    border: solid #000 !important;
    border-width: 1px 0 0 1px !important;
    width:100% !important;
    margin-right:10px !important;
  }
  th,
  td {
    border: solid #000 !important;
  }
  .maintb{
    font-size: 14px !important;
  }
}
`
			d.print(document.getElementById('orderinvoiceContent'), cssText);

		},
        async  checkCrossDockEnabled(){
			return new Promise((resolve, reject) => {
				var userToken = window.localStorage.getItem('userToken');
				var myStr = userToken.replace(/"/g, '');
				this.input1 = {};
				this.input1.clientid = this.clientid;
				this.input1.warehouseid =this.warehouseid;
				axios({
				  method: 'GET',
				  'url': `${apiUrl.api_url}checkCrossDockEnabled`,
				  'params': this.input1,
				  headers: {
					'Authorization': 'Bearer ' + myStr,
				  },
				})
				.then(result => {
				  if (result.data) {
					this.checkCrossDock = result.data.data;
					resolve(this.checkCrossDock);
				  } else {
					reject('Data not found');
				  }
				})
				.catch(error => {
				  reject(error); // Reject the Promise with the error
				});
			  });

		},


	} // end methods

}



// WEBPACK FOOTER //
// ./src/views/components/reports/order/order.component.js